export const eventListQueryKeys = {
  all: ["EVENT_LIST"],
  getEventList: (options?: object) => [...eventListQueryKeys.all, { options }],
  getProjectList: (options?: object) => [
    ...eventListQueryKeys.all,
    "PROJECT_LIST",
    { options },
  ],
};
